import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  ViewChild
} from '@angular/core';
import { Project } from '@modules/projects/shared/models/project.model';
import { IProjectStage } from '@modules/projects/shared/interfaces/project-stage.interface';
import { IProjectsTimelineResourceEvent } from '@modules/projects/modules/projects-timeline/shared/interfaces/projects-timeline-resource-event.interface';
import { ResourceApi } from '@fullcalendar/resource';
import { ProjectStage } from '@shared/enums/project-stage.enum';
import { WindowHelper } from '@shared/helpers/window.helper';
import { SidenavService } from '@shared/services/sidenav/sidenav.service';
import { ProjectsTimelineSidenavComponent } from '@modules/projects/shared/components/projects-timeline-sidenav/projects-timeline-sidenav.component';

@Component({
  selector: 'projects-timeline-resource-label',
  templateUrl: './projects-timeline-resource-label.component.html',
  styleUrls: ['./projects-timeline-resource-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectsTimelineResourceLabelComponent implements OnInit {
  ProjectStage = ProjectStage;
  WindowHelper = WindowHelper;

  resource: ResourceApi;
  opened: boolean = false;
  eventEmitter: EventEmitter<IProjectsTimelineResourceEvent> =
    new EventEmitter<IProjectsTimelineResourceEvent>();
  project: Project;
  resourceStage: IProjectStage;
  loading: boolean = false;
  openedPopover: { project: Project; parentElement: HTMLBaseElement };
  onProjectChange: EventEmitter<{ project: Project; oldStage?: ProjectStage }> = new EventEmitter<{
    project: Project;
    oldStage?: ProjectStage;
  }>();

  @ViewChild('resourceLabel') resourceLabel: ElementRef;

  constructor(
    private changes: ChangeDetectorRef,
    private sidenav: SidenavService
  ) {}

  ngOnInit(): void {
    this.setProjectAndStage();
  }

  setProjectAndStage(): void {
    if (this.resource._resource.parentId) {
      this.project = new Project(this.resource._resource.extendedProps);
    } else {
      this.resourceStage = this.resource._resource.extendedProps as IProjectStage;
    }
  }

  toggle(): void {
    if (this.loading) return;

    this.loading = true;
    this.eventEmitter.emit({
      open: !this.resourceStage.opened,
      stage: this.resource.extendedProps.stage,
      resource: this.resource
    });

    setTimeout(() => {
      this.loading = false;
      this.changes.detectChanges();
    }, 300);
  }

  openProjectSidenav(): void {
    if (!this.project) return;

    this.sidenav.open(
      ProjectsTimelineSidenavComponent,
      { maxWidth: '600px', hideBackdrop: true },
      { project: this.project, replaceUrl: true }
    );
  }
}
